import { h, Component } from 'preact';

import style from '../../style/product.sass';
import HandlebarsHandler from '../util/handlebarsHandler.js';

export default class Product extends Component {
  render(props) {
    if(!props.mergedLandingPageData){
      return null;
    }
    const handlebarsHandler = new HandlebarsHandler();
    const bullets = [];
    const badges = [];
    const bulletListStyle = [style.bullets];
    let proPartnerHeader = null;
    if(props.campaignType === 'repair'){
      proPartnerHeader = (<h2 className={style.bulletsHeader}>WHY CHOOSE A PRO PARTNER</h2>);
      bulletListStyle.push(style.bulletsRepair);
    }
    for (let property in props.mergedLandingPageData.bullets) {
      let liHtml = handlebarsHandler.renderToHtml(
        'productBullet'+property,
        props.mergedLandingPageData.bullets[property],
        props.mergedLandingPageData
      );
      if(props.campaignType === 'repair'){
        bullets.push(
          <li>
            <img src={'assets/images/pro-partner-check.svg'} className={style.proPartnerCheck} />
            <span dangerouslySetInnerHTML={{__html: liHtml}}></span>
          </li>
        );
      }else{
        bullets.push(<li><span dangerouslySetInnerHTML={{__html: liHtml}}></span></li>);
      }
    }
    for (let property in props.mergedLandingPageData.badges) {
      if(props.campaignType !== 'repair'){
        badges.push(
          <li>
            <img src={'assets/images/badges/'+props.mergedLandingPageData.badges[property]+'.png'} />
          </li>
        );
      }
    }
    return (
      <div className={style.infoContainer}>
        {proPartnerHeader}
        <ul className={bulletListStyle.join(' ')}>
          {bullets}
        </ul>
        <ul className={style.badges}>
          {badges}
        </ul>
      </div>
    );
  }
}